/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Quick_Add_PlaceholderInputs */

const en_quick_add_placeholder = /** @type {(inputs: Quick_Add_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add item, e.g. 2 lemons`)
};

const de_quick_add_placeholder = /** @type {(inputs: Quick_Add_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel hinzufügen, z. B. 2 Zitronen`)
};

/**
* | output |
* | --- |
* | "Add item, e.g. 2 lemons" |
*
* @param {Quick_Add_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const quick_add_placeholder = /** @type {((inputs?: Quick_Add_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Quick_Add_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_quick_add_placeholder(inputs)
	return en_quick_add_placeholder(inputs)
});